module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    staticClass: "mt-2",
    attrs: {
      "dense": "",
      "scroll-off-screen": "",
      "scroll-target": "#scrolling-tech"
    }
  }, [_c('v-toolbar-title', [_vm._v("Post Hearing Letter Information")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": _vm.previewLetter
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("rate_review")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Preview Letter")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": _vm.send
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("save")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Send Letter")])])], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "pr-1": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Delivery Method",
      "disabled": "",
      "name": "deliveryMethod"
    },
    model: {
      value: (_vm.mergeFieldData.deliveryMethod),
      callback: function($$v) {
        _vm.$set(_vm.mergeFieldData, "deliveryMethod", $$v)
      },
      expression: "mergeFieldData.deliveryMethod"
    }
  })], 1), _vm._v(" "), (_vm.mergeFieldData.externalContacts) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "outline": "",
      "dismissable": "",
      "type": "error"
    },
    model: {
      value: (_vm.emailError),
      callback: function($$v) {
        _vm.emailError = $$v
      },
      expression: "emailError"
    }
  }, [_vm._v("Please enter a valid e-mail address")]), _vm._v(" "), _c('v-autocomplete', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.mergeFieldData.externalContacts.data,
      "box": "",
      "hide-no-data": "",
      "chips": "",
      "label": "To:",
      "item-text": "firstName",
      "item-value": "eMail",
      "multiple": "",
      "required": "",
      "name": "email",
      "error-messages": _vm.errors.collect('email')
    },
    on: {
      "blur": function($event) {
        _vm.emailError = false
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addManualEntry($event)
      }
    },
    scopedSlots: _vm._u([{
      key: "prepend-item",
      fn: function() {
        return [_vm._v("\n                            *Add more recipient(s) by typing e-mail address and hitting enter\n                        ")]
      },
      proxy: true
    }, {
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          staticClass: "chip--select-multi",
          attrs: {
            "selected": data.item.selected,
            "close": ""
          },
          on: {
            "input": function($event) {
              return _vm.remove(data.item)
            }
          }
        }, [_vm._v("\n                                " + _vm._s(data.item.eMail) + "\n                            ")])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [(typeof data !== 'object') ? [_c('v-list-tile-content', {
          domProps: {
            "textContent": _vm._s(data.item.firstName)
          }
        })] : [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(data.item.lastName) + ", " + _vm._s(data.item.firstName) + " - " + _vm._s(data.item.eMail))])], 1)]]
      }
    }]),
    model: {
      value: (_vm.mergeFieldData.externalContacts.selected),
      callback: function($$v) {
        _vm.$set(_vm.mergeFieldData.externalContacts, "selected", $$v)
      },
      expression: "mergeFieldData.externalContacts.selected"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "pr-1": "",
      "pb-0": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Policy #",
      "name": "policyNum",
      "error-messages": _vm.errors.collect('policyNum')
    },
    model: {
      value: (_vm.mergeFieldData.policyNumber),
      callback: function($$v) {
        _vm.$set(_vm.mergeFieldData, "policyNumber", $$v)
      },
      expression: "mergeFieldData.policyNumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "pb-0": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "BWC Claim #",
      "name": "claimNum",
      "error-messages": _vm.errors.collect('claimNum')
    },
    model: {
      value: (_vm.mergeFieldData.claimNumber),
      callback: function($$v) {
        _vm.$set(_vm.mergeFieldData, "claimNumber", $$v)
      },
      expression: "mergeFieldData.claimNumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "pr-1": "",
      "pt-0": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Employer Name",
      "name": "employerName",
      "error-messages": _vm.errors.collect('employerName')
    },
    model: {
      value: (_vm.mergeFieldData.employerName),
      callback: function($$v) {
        _vm.$set(_vm.mergeFieldData, "employerName", $$v)
      },
      expression: "mergeFieldData.employerName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "pr-1": "",
      "pt-0": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Claimant Name",
      "name": "claimantName",
      "error-messages": _vm.errors.collect('claimantName')
    },
    model: {
      value: (_vm.mergeFieldData.claimantName),
      callback: function($$v) {
        _vm.$set(_vm.mergeFieldData, "claimantName", $$v)
      },
      expression: "mergeFieldData.claimantName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "pr-1": "",
      "pt-0": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Contact Name",
      "name": "contactName",
      "error-messages": _vm.errors.collect('contactName')
    },
    model: {
      value: (_vm.mergeFieldData.contactName),
      callback: function($$v) {
        _vm.$set(_vm.mergeFieldData, "contactName", $$v)
      },
      expression: "mergeFieldData.contactName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "pr-1": "",
      "pt-0": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Contact Name Proper Case",
      "name": "contactNameProperCase",
      "error-messages": _vm.errors.collect('contactNameProperCase')
    },
    model: {
      value: (_vm.mergeFieldData.contactNameProperCase),
      callback: function($$v) {
        _vm.$set(_vm.mergeFieldData, "contactNameProperCase", $$v)
      },
      expression: "mergeFieldData.contactNameProperCase"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "pr-1": "",
      "pt-0": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Hearing Issues",
      "name": "hearingIssue",
      "error-messages": _vm.errors.collect('hearingIssue')
    },
    model: {
      value: (_vm.mergeFieldData.hearingIssues),
      callback: function($$v) {
        _vm.$set(_vm.mergeFieldData, "hearingIssues", $$v)
      },
      expression: "mergeFieldData.hearingIssues"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md5": "",
      "pr-1": "",
      "pt-0": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Account Manager Name",
      "name": "accountManagerName",
      "required": "",
      "error-messages": _vm.errors.collect('accountManagerName')
    },
    model: {
      value: (_vm.mergeFieldData.accountManagerName),
      callback: function($$v) {
        _vm.$set(_vm.mergeFieldData, "accountManagerName", $$v)
      },
      expression: "mergeFieldData.accountManagerName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "pr-1": "",
      "pt-0": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Account Manager Phone",
      "name": "accountManagerPhone",
      "required": "",
      "error-messages": _vm.errors.collect('accountManagerPhone')
    },
    model: {
      value: (_vm.mergeFieldData.accountManagerPhone),
      callback: function($$v) {
        _vm.$set(_vm.mergeFieldData, "accountManagerPhone", $$v)
      },
      expression: "mergeFieldData.accountManagerPhone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md5": "",
      "pr-1": "",
      "pt-0": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "label": "Account Manager Email",
      "name": "accountManagerEmail",
      "required": "",
      "error-messages": _vm.errors.collect('accountManagerEmail')
    },
    model: {
      value: (_vm.mergeFieldData.accountManagerEmail),
      callback: function($$v) {
        _vm.$set(_vm.mergeFieldData, "accountManagerEmail", $$v)
      },
      expression: "mergeFieldData.accountManagerEmail"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "pr-1": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-autocomplete', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.$store.state.refData.hearingOfficerTypes,
      "box": "",
      "hide-no-data": "",
      "label": "Hearing Officer Type",
      "item-text": "description",
      "item-value": "id",
      "return-object": "",
      "required": "",
      "chips": "",
      "deletable-chips": "",
      "name": "hearingOfficerType",
      "error-messages": _vm.errors.collect('hearingOfficerType')
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [(typeof data !== 'object') ? [_c('v-list-tile-content', {
          domProps: {
            "textContent": _vm._s(data.item)
          }
        })] : [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(data.item.description))])], 1)]]
      }
    }]),
    model: {
      value: (_vm.mergeFieldData.hearingOfficerType),
      callback: function($$v) {
        _vm.$set(_vm.mergeFieldData, "hearingOfficerType", $$v)
      },
      expression: "mergeFieldData.hearingOfficerType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "pr-1": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-autocomplete', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "items": _vm.$store.state.refData.hearingOfficers,
      "box": "",
      "hide-no-data": "",
      "label": "Hearing Officer Name",
      "item-text": "description",
      "item-value": "id",
      "return-object": "",
      "required": "",
      "chips": "",
      "deletable-chips": "",
      "name": "hearingOfficerName",
      "error-messages": _vm.errors.collect('hearingOfficerName')
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [(typeof data !== 'object') ? [_c('v-list-tile-content', {
          domProps: {
            "textContent": _vm._s(data.item)
          }
        })] : [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(data.item.description))])], 1)]]
      }
    }]),
    model: {
      value: (_vm.mergeFieldData.hearingOfficerName),
      callback: function($$v) {
        _vm.$set(_vm.mergeFieldData, "hearingOfficerName", $$v)
      },
      expression: "mergeFieldData.hearingOfficerName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "pr-1": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Was IW present at hearing?"
    },
    model: {
      value: (_vm.mergeFieldData.iwPresent),
      callback: function($$v) {
        _vm.$set(_vm.mergeFieldData, "iwPresent", $$v)
      },
      expression: "mergeFieldData.iwPresent"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm5": "",
      "md3": "",
      "pr-1": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Was IW's attorney present?"
    },
    model: {
      value: (_vm.mergeFieldData.iwAttorneyPresent),
      callback: function($$v) {
        _vm.$set(_vm.mergeFieldData, "iwAttorneyPresent", $$v)
      },
      expression: "mergeFieldData.iwAttorneyPresent"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm7": "",
      "md6": "",
      "pr-1": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.mergeFieldData.iwAttorneyPresent
      }),
      expression: "{required:mergeFieldData.iwAttorneyPresent}"
    }],
    attrs: {
      "label": "IW Attorney's Name",
      "name": "attorneyName",
      "disabled": !_vm.mergeFieldData.iwAttorneyPresent,
      "error-messages": _vm.errors.collect('attorneyName')
    },
    model: {
      value: (_vm.mergeFieldData.iwAttorneyName),
      callback: function($$v) {
        _vm.$set(_vm.mergeFieldData, "iwAttorneyName", $$v)
      },
      expression: "mergeFieldData.iwAttorneyName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "lg6": "",
      "pr-1": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.attorneyReliedOnRequired),
      expression: "attorneyReliedOnRequired"
    }],
    staticClass: "purple-input",
    attrs: {
      "label": "The injured worker's attorney relied on:",
      "auto-grow": "",
      "counter": 800,
      "disabled": !_vm.mergeFieldData.iwAttorneyPresent,
      "name": "iwAttorneyReferredTo",
      "error-messages": _vm.errors.collect('iwAttorneyReferredTo')
    },
    model: {
      value: (_vm.mergeFieldData.iwAttorneyReferredTo),
      callback: function($$v) {
        _vm.$set(_vm.mergeFieldData, "iwAttorneyReferredTo", $$v)
      },
      expression: "mergeFieldData.iwAttorneyReferredTo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "lg6": "",
      "pr-1": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:800|required'),
      expression: "'max:800|required'"
    }],
    staticClass: "purple-input",
    attrs: {
      "label": "We reviewed the facts for the hearing officer and referred to:",
      "auto-grow": "",
      "counter": 800,
      "name": "referredTo",
      "error-messages": _vm.errors.collect('referredTo')
    },
    model: {
      value: (_vm.mergeFieldData.referredTo),
      callback: function($$v) {
        _vm.$set(_vm.mergeFieldData, "referredTo", $$v)
      },
      expression: "mergeFieldData.referredTo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "lg6": "",
      "pr-1": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:800|required'),
      expression: "'max:800|required'"
    }],
    staticClass: "purple-input",
    attrs: {
      "label": "The hearing officer decided to:",
      "auto-grow": "",
      "counter": 800,
      "name": "hearingOfficerDecision",
      "error-messages": _vm.errors.collect('hearingOfficerDecision')
    },
    model: {
      value: (_vm.mergeFieldData.hearingOfficerDecision),
      callback: function($$v) {
        _vm.$set(_vm.mergeFieldData, "hearingOfficerDecision", $$v)
      },
      expression: "mergeFieldData.hearingOfficerDecision"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "pr-1": "",
      "pb-0": "",
      "pt-0": ""
    }
  }, [_c('v-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:800'),
      expression: "'max:800'"
    }],
    staticClass: "purple-input",
    attrs: {
      "label": "General Comments:",
      "auto-grow": "",
      "counter": 800,
      "name": "generalComments",
      "error-messages": _vm.errors.collect('generalComments')
    },
    model: {
      value: (_vm.mergeFieldData.generalComments),
      callback: function($$v) {
        _vm.$set(_vm.mergeFieldData, "generalComments", $$v)
      },
      expression: "mergeFieldData.generalComments"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-toolbar', [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": _vm.previewLetter
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("rate_review")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Preview Letter")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": _vm.send
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("save")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Send Letter")])])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8dec8768", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8dec8768"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/src/portalhome/docketing/letters/posthearingletter.vue.html
// module id = 592
// module chunks = 0